import { Color as BaseColor } from "three";

export default class Color extends BaseColor
{
    constructor( r, g, b ) {
        super( r, g, b );
    }

    set( r, g, b ) {

        if ( g === undefined && b === undefined ) {

            // r is THREE.Color, hex or string

            const value = r;

            if ( value && value.isColor ) {

                this.copy( value );

            } else if ( typeof value === 'number' ) {

                this.setHex( value );

            } else if ( typeof value === 'string' && value.startsWith('#') ) {

                this.setHex( Number( '0x' + value.substring( 1 ) ) );

            } else if ( typeof value === 'string' ) {

                this.setStyle( value );

            }

        } else {

            this.setRGB( r, g, b );

        }

        return this;

    }
}